import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {CreateFundRepresentativeDTO, useCreateFundRepresentative} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddFundRepresentativeFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddFundRepresentativeForm = ({setOpen}: UseAddFundRepresentativeFormProps) => {
  const {emailSchema, displayNameSchema} = useSchemes();
  const createMutation = useCreateFundRepresentative();

  const onSubmit = async (values: CreateFundRepresentativeDTO) => {
    try {
      await createMutation.mutateAsync(values);
      setOpen(false);
    } catch {
      // Ошибка отображается через submitError (createMutation.error)
    }
  };

  const formik = useFormik({
    initialValues: {
      fundId: '',
      displayName: '',
      email: '',
    },
    validationSchema: Yup.object({
      fundId: Yup.string().required('Фонд обязателен'),
      displayName: displayNameSchema,
      email: emailSchema,
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createMutation.isPending,
    submitError: createMutation.error
      ? (createMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    resetForm: formik.resetForm,
    submitForm: () => formik.handleSubmit(),
  };
};
